import { useEffect, useState, useContext, useRef, useCallback } from "react"
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify"

import { useEstadoApp } from "../context/EstadoAppContext";
import {initiateSocketConnection} from "../service/socketio";

import { useLocalStorage } from "../hooks/useLocalStorage";

import TramitacionesComponent from "../components/TramitacionesComponent";

const EVENT_NAME = 'redisKeyDeleted';

export const TramitacionesPage = () => {

	const { estadoAppX, cambiarEstadoApp } = useEstadoApp();

    const location = useLocation();
    //const [showToast, setShowToast] = useState(false); //no usar por ahora
    const { search } = useLocation();
    const { setItem, removeItem } = useLocalStorage();

    const [arrayEditando, setArrayEditando] = useState([]);
    const [socket, setSocket] = useState(null);
    const socketRef = useRef(null);
    const [isSocketConnected, setIsSocketConnected] = useState(false);

    const [isEditing, setIsEditing] = useState(false);

    const [key, setKey] = useState(null); //17oct2025: para claves eliminadas

    const consultar_array_editando = async () => {
        console.log("CONSULTANDO arrayEditando")
        const url = `/api/arrayEditando`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }

        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            if(result){
                setArrayEditando(result);
            } else {
                console.log("No hay datos en arrayEditando")
                setArrayEditando([]);
            }
        } catch (error) {
            console.error('Error al buscar obras:', error);
        }        
    }

    const handleIsEditing = useCallback((newIsEditing) => {
        console.log("EJECUTA??", newIsEditing)
        setIsEditing(newIsEditing);
        setItem("isEditing", isEditing);
    }, []);

    /*useEffect(() => {
        console.log("EJECUTA B - isEditing", isEditing)
        if(isEditing){
            setItem("isEditing", isEditing);
            //setItem("idPartidoObra", idPartidoObra)
        } else {
            removeItem("isEditing");
        }
    }, [isEditing])*/

    useEffect(() => {
        const params = new URLSearchParams(search);
        if (params.get('edicionExitosa')) {
            //setShowToast(true); //no usar por ahora
            toast("¡Operación exitosa!, registro editado")
            // Limpiar el parámetro de la URL
            const newSearch = new URLSearchParams(search);
            newSearch.delete('edicionExitosa');
            const newUrl = [location.pathname, newSearch.toString()].filter(Boolean).join('?');
            window.history.replaceState({}, '', newUrl);
        }
    }, [location.search]);    

	useEffect(() => {
		console.log("estadoAppX", estadoAppX)
		cambiarEstadoApp("inicial")
	}, []) //cuando se monta el componente volver al estado inicial
	//const {isAuthenticated} = useContext(AuthContext)
    
    // Inicializar conexión Socket.IO (una sola vez)
    useEffect(() => {
        const s = initiateSocketConnection();
        setSocket(s);
        socketRef.current = s;

        const onConnect = () => {
            console.log('[socket] connected', s.id);
            setIsSocketConnected(true);
        };
        const onDisconnect = () => {
            console.log('[socket] disconnected');
            setIsSocketConnected(false);
        };

        s.on('connect', onConnect);
        s.on('disconnect', onDisconnect);

        // 2. Escuchar el evento
        s.on(EVENT_NAME, (payload) => {
            console.log('Evento recibido:', payload);
            setKey(payload.key);
            //PRO AHORA NO---- >setMessage(`✅ ¡Clave "${payload.key}" eliminada! Notificación recibida a las ${new Date(payload.timestamp).toLocaleTimeString()}`);

            //No recarga las obras, solo chequea el array_editando
            consultar_array_editando();

        });

        return () => {
            s.off('connect', onConnect);
            s.off('disconnect', onDisconnect);
            s.off(EVENT_NAME);
            try { s.close(); } catch (e) { }
        };
    }, []);

    useEffect(() => {
        consultar_array_editando(); //ahora para todos los usuarios

    }, [])

    useEffect(() => {
        if (socket) {
            console.log("ESTÄ ESCUCHANDO??")
            const procesarArray = (data) => {
                console.log("ESCUCHAR CAMBIOS aca´ --->", data)
                setArrayEditando(data)
            }
            socket.on("array_editando", procesarArray)

            return () => {
                socket.off("array_editando", procesarArray)
            }
        }
    }, [socket])

	return (
        <>
            {/* {showToast && (
                <div className="fixed top-4 right-4 z-50">
                    <div className="bg-green-500 text-white px-4 py-2 rounded shadow-lg">
                        ¡Operación exitosa!, registro editado
                    </div>
                </div>
            )} */}
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 dark:bg-black dark:text-white">
                <div className="w-full sm:mx-auto sm:w-full sm:max-w-sm">
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:bg-black dark:text-white">
                        EN DESARROLLO: Descarga Informes - Privado
                    </h2>
                </div>
            </div>
            <ToastContainer />
        </>
	)
}